import { supabase } from './supabase';

// Notice functions
export const createNotice = async ({ title, content, isPinned = false }) => {
  const { data: notice, error } = await supabase
    .from('notices')
    .insert({
      title,
      content,
      is_pinned: isPinned,
    })
    .select()
    .single();

  if (error) throw error;
  return notice;
};

export const getNotices = async ({ page = 1, limit = 10 }) => {
  const from = (page - 1) * limit;
  const to = from + limit - 1;

  const { data: notices, count, error } = await supabase
    .from('notices')
    .select(`
      *,
      author:user_id (
        id,
        email,
        profiles (
          username,
          avatar_url
        )
      )
    `, { count: 'exact' })
    .order('is_pinned', { ascending: false })
    .order('created_at', { ascending: false })
    .range(from, to);

  if (error) throw error;
  return { notices, count };
};

// 합격 스토리 functions
export const createSuccessStory = async ({
  title,
  content,
  exam_date,
  exam_score,
  study_period,
  state,
  youtube_url
}) => {
  const { data: story, error } = await supabase
    .from('success_stories')
    .insert({
      title,
      content,
      exam_date,
      exam_score,
      study_period,
      state,
      youtube_url
    })
    .select()
    .single();

  if (error) throw error;
  return story;
};

export const getSuccessStories = async ({ page = 1, limit = 10 }) => { // 합격 스토리 목록
  const from = (page - 1) * limit;
  const to = from + limit - 1;

  const { data: stories, count, error } = await supabase
    .from('success_stories')
    .select('*')
    .order('created_at', { ascending: false })
    .range(from, to);

  if (error) throw error;
  return { stories, count };
};

// Study Tips functions
export const createStudyTip = async ({ title, content, category }) => {
  const { data: tip, error } = await supabase
    .from('study_tips')
    .insert({
      title,
      content,
      category
    })
    .select()
    .single();

  if (error) throw error;
  return tip;
};

export const getStudyTips = async ({ category, page = 1, limit = 10 }) => {
  let query = supabase
    .from('study_tips')
    .select(`
      *,
      author:user_id (
        id,
        email,
        profiles (
          username,
          avatar_url
        )
      )
    `, { count: 'exact' });

  if (category) {
    query = query.eq('category', category);
  }

  const from = (page - 1) * limit;
  const to = from + limit - 1;

  const { data: tips, count, error } = await query
    .order('created_at', { ascending: false })
    .range(from, to);

  if (error) throw error;
  return { tips, count };
};

// Study Groups functions
export const createStudyGroup = async ({ 
  title, 
  content, 
  maxMembers, 
  startDate, 
  endDate 
}) => {
  const { data: group, error } = await supabase
    .from('study_groups')
    .insert({
      title,
      content,
      max_members: maxMembers,
      start_date: startDate,
      end_date: endDate
    })
    .select()
    .single();

  if (error) throw error;
  return group;
};

export const getStudyGroups = async ({ status = 'recruiting', page = 1, limit = 10 }) => {
  const from = (page - 1) * limit;
  const to = from + limit - 1;

  const { data: groups, count, error } = await supabase
    .from('study_groups')
    .select(`
      *,
      author:user_id (
        id,
        email,
        profiles (
          username,
          avatar_url
        )
      )
    `, { count: 'exact' })
    .eq('status', status)
    .order('created_at', { ascending: false })
    .range(from, to);

  if (error) throw error;
  return { groups, count };
};

// Q&A functions
export const createQnA = async ({ title, content }) => {
  const { data: qna, error } = await supabase
    .from('qna_posts')
    .insert({
      title,
      content
    })
    .select()
    .single();

  if (error) throw error;
  return qna;
};

export const getQnAs = async ({ isSolved, page = 1, limit = 10 }) => {
  let query = supabase
    .from('qna_posts')
    .select(`
      *,
      author:user_id (
        id,
        email,
        profiles (
          username,
          avatar_url
        )
      )
    `, { count: 'exact' });

  if (typeof isSolved === 'boolean') {
    query = query.eq('is_solved', isSolved);
  }

  const from = (page - 1) * limit;
  const to = from + limit - 1;

  const { data: qnas, count, error } = await query
    .order('created_at', { ascending: false })
    .range(from, to);

  if (error) throw error;
  return { qnas, count };
};

export const markQnAasSolved = async (qnaId) => {
  const { data: qna, error } = await supabase
    .from('qna_posts')
    .update({ is_solved: true })
    .eq('id', qnaId)
    .select()
    .single();

  if (error) throw error;
  return qna;
}; 